import { mapKeys, camelCase } from 'lodash'
import WorkSchedule from '@/api/hr/work-schedule'
import EmployeeProfile from '@/api/hr/employee'

import { baseState, baseMutations, Pagination } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  shifts: [],
  special_keywords: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SHIFTS(state, data) {
    state.shifts = data
  },
  SET_SPECIAL_KEYWORDS(state, data) {
    state.special_keywords = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return WorkSchedule.get({ params }).then(response => {
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return WorkSchedule.store(data)
  },

  save(context, data) {
    return WorkSchedule.save(data)
  },

  getSpecialKeyword(context, id) {
    let params = Object.assign({}, { shift_id: id })
    WorkSchedule.getSpecialKeyword({ params }).then(response => {
      context.commit('SET_SPECIAL_KEYWORDS', response)
    })
  },
  async dataBeforeCreate(context) {
    if (!context.state.shifts.length > 0) {
      let response = await WorkSchedule.getShift()
      context.commit('SET_SHIFTS', response.data)
    }
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        hris_employee_profiles: 'employee_id,employee_name_en,employee_name_kh,card_id'
      },
      filter: {
        filter_shift: attributes.shift_id
      },
      ...attributes
    }

    return EmployeeProfile.get({ params }).then(response => {
      return Promise.resolve(response)
    })
  },

  exportExcel(context, { ...attributes }) {
    return WorkSchedule.exportExcel(attributes)
  }
}
